import { useEffect, useState } from "react";
import { Roles } from "../../../../../utils/enums";
import { InputModel } from "../../../../../utils/types";
import { Item } from "../../../../../utils/types/generals";
import { removeAllReference } from "../../../../../utils/methods/removedReference";
import { ButtonExecution } from "../components/buttonExecution";
import { Box } from "@mui/material";
import { useContextState } from "../../../../../hooks/theme";

const useInput = ({ items, counter, cleanFilter, getExecutionDetalData, queryv2, lastVersionId, getVersionQuestionaire, applyQuestionFilter, onChange, resetQuestionFilter }: { items?: { [x: string]: Item[] }, counter: number | null, cleanFilter: () => void, getExecutionDetalData: (idversion: string, query?: string) => Promise<void>, queryv2: string, lastVersionId: string, getVersionQuestionaire: (query?: string) => Promise<void>, applyQuestionFilter: () => void, onChange?: (e: any) => void, resetQuestionFilter?: () => void }) => {

  const { colors: color } = useContextState()
  const [input, setInput] = useState<{ [x: string]: InputModel }>({
    /* areas: {
        label: 'general.tags.area',
        translate: true,
        name: 'areas',
        type: 'filter-select',
        items: items?.areas ?? [],
        value: null,
        size: {
          xl: 3,
          lg: 3,
          md: 3,
          sm: 6,
          xs: 12,
        },
    },
    departments: {
        label: 'general.tags.department',
        translate: true,
        name: 'departments',
        type: 'filter-select',
        items: items?.departments ?? [],
        value: null,
        size: {
          xl: 3,
          lg: 3,
          md: 3,
          sm: 6,
          xs: 12,
        },
    }, */
    divisions: {
      label: 'general.tags.division',
      translate: true,
      name: 'divisions',
      type: 'filter-select',
      items: items?.divisions ?? [],
      value: null,
      size: {
        xl: 4,
        lg: 4,
        md: 4,
        sm: 12,
        xs: 12,
      },
    },
    zoneId: {
      label: 'general.tags.zone',
      translate: true,
      name: 'zoneId',
      type: 'filter-select',
      items: items?.zoneId ?? [],
      value: [],
      size: {
        xl: 4,
        lg: 4,
        md: 4,
        sm: 12,
        xs: 12,
      },
    },
    childZone: {
      label: 'general.tags.class',
      translate: true,
      name: 'childZone',
      type: 'filter-select',
      items: items?.childZone ?? [],
      value: null,
      size: {
        xl: 4,
        lg: 4,
        md: 4,
        sm: 12,
        xs: 12,
      },
    },
    keyCodeId: {
      label: 'general.tags.idStore',
      translate: true,
      name: 'keyCodeId',
      type: 'filter-select',
      items: items?.keyCodeId ?? [],
      value: [],
      size: {
        xl: 4,
        lg: 4,
        md: 4,
        sm: 12,
        xs: 12,
      },
    },
    userTypeId: {
      label: 'general.tags.userType',
      translate: true,
      name: 'userTypeId',
      type: 'filter-select',
      items: items?.userTypeId ?? [],
      value: [],
      size: {
        xl: 4,
        lg: 4,
        md: 4,
        sm: 12,
        xs: 12,
      },
    },
    userId: {
      label: 'general.tags.user',
      translate: true,
      name: 'userId',
      type: 'filter-select',
      items: items?.userId ?? [],
      value: [],
      size: {
        xl: 4,
        lg: 4,
        md: 4,
        sm: 12,
        xs: 12,
      },
    },
    from: {
      label: 'general.tags.from',
      translate: true,
      name: 'from',
      type: 'date',
      value: null,
      rest: {
        max: 'to',
      },
      size: {
        xl: 4,
        lg: 4,
        md: 4,
        sm: 12,
        xs: 12,
      },
    },
    to: {
      label: 'general.tags.to',
      translate: true,
      name: 'to',
      type: 'date',
      value: null,
      rest: {
        min: 'from',
      },
      size: {
        xl: 4,
        lg: 4,
        md: 4,
        sm: 12,
        xs: 12,
      },
    },
    status: {
      label: 'general.tags.status',
      translate: true,
      name: 'status',
      type: 'filter-select',
      items: items?.status ?? [],
      value: null,
      size: {
        xl: 4,
        lg: 4,
        md: 4,
        sm: 12,
        xs: 12,
      },
    },
    answerType: {
      label: 'general.tags.answerType',
      translate: true,
      name: 'answerType',
      type: 'select-search',
      items: [],
      value: [],
      size: {
        xl: 4,
        lg: 4,
        md: 4,
        sm: 12,
        xs: 12,
      },
    },
    questions: {
      label: 'general.tags.questions',
      translate: true,
      name: 'questions',
      type: 'filter-select',
      items: items?.questions ?? [],
      value: [],
      rest: {
        key: `questions-input-${counter || 0}-${items?.questions?.length || 0}`,
        isOptionEqualToValue: (option: any, value: any) => {
          const optionValue = typeof option === 'string' ? option : option?.value;
          const valueValue = typeof value === 'string' ? value : value?.value;
          return optionValue === valueValue;
        }
      },
      size: {
        xl: 4,
        lg: 4,
        md: 4,
        sm: 12,
        xs: 12,
      },
      // wrapChildren: ({ children, id }) => {

      //   return (
      //     <ButtonExecution children={children} id={id} counter={counter} cleanFilter={cleanFilter} getExecutionDetalData={getExecutionDetalData} queryv2={queryv2} lastVersionId={lastVersionId} getVersionQuestionaire={getVersionQuestionaire} />
      //   )
      // }
    },
    questionButtons: {
      label: '',
      translate: false,
      name: 'questionButtons',
      type: 'textArea',
      items: [],
      value: null,
      size: {
        xl: 4,
        lg: 4,
        md: 4,
        sm: 12,
        xs: 12,
      },
      rest: {
        style: { display: 'none' }
      }
    },

  })

  const disabledInputs = (data: { inputs: string[]; value: boolean }) => {
    let copyInput: {
      [x: string]: InputModel
    } = removeAllReference(input)

    data?.inputs?.forEach((item) => {
      copyInput[item] = {
        ...copyInput[item],
        rest: {
          ...(copyInput[item]?.rest ?? {}),
          disabled: data.value,
        },
      }
    })

    setInput((prev) => ({
      ...prev,
      ...copyInput,
    }))
  }

  useEffect(() => {
    setInput((prevInput) => {
      let body = { ...prevInput }
      Object.entries(prevInput).forEach(([key, itemInputs]) => {
        if (items?.[key]) {
          body = {
            ...body,
            [key]: {
              ...itemInputs,
              items: items[key]
            }
          }
        }
      })

      if (body.questions && (counter === null || counter === 0)) {
        body = {
          ...body,
          questions: {
            ...body.questions,
            value: [],
            items: items?.questions ?? []
          }
        }
      }

      return body
    });
  }, [items, counter])

  useEffect(() => {
    setInput((prevInput) => {
      if (!prevInput.questionButtons) return prevInput;

      return {
        ...prevInput,
        questionButtons: {
          ...prevInput.questionButtons,
          wrapChildren: ({ children, id }) => (
            <ButtonExecution
              children={<div></div>}
              id={id}
              counter={counter}
              cleanFilter={cleanFilter}
              getExecutionDetalData={getExecutionDetalData}
              queryv2={queryv2}
              lastVersionId={lastVersionId}
              getVersionQuestionaire={getVersionQuestionaire}
              applyQuestionFilter={applyQuestionFilter}
              onChange={onChange}
              resetQuestionFilter={resetQuestionFilter}
            />
          )
        }
      }
    });
  }, [counter, lastVersionId, cleanFilter, getExecutionDetalData, queryv2, getVersionQuestionaire, applyQuestionFilter, onChange, resetQuestionFilter])

  return { input, disabledInputs }
}

export { useInput }
